import React     from 'react';
import PropTypes from 'prop-types';
import Flux      from '../../../flux/Flux';

function withCategories(WrappedComponent) {

	class withCategories extends React.Component {
		constructor(props) {
			super(props);

			this.state = {
				data:    [],
				loading: true,
			};

			this.getCollection = this.getCollection.bind(this);
		}

		componentDidMount() {
			this.getCollection();
		}

		componentDidUpdate(prevProps) {
			if (this.props.sort !== prevProps.sort) {
				this.getCollection();
			}
		}

        getCollection() {
            const args = {
                order:           this.props.sort,
                first:           this.props.first,
                firstModels:     this.props.firstModels,
                collectionNames: this.props.collectionNames,
            };

            Flux.CollectionsV2.getCollections({...args}, (data) => {
                this.setState({
                    data: data.data.collections_v2, loading: false
                });
                if (this.props.onLoaded) {
                    this.props.onLoaded(data);
                }
            });
        }

		render() {
			return <WrappedComponent {...this.state} {...this.props} />;
		}
	}

	withCategories.propTypes    = {
		sort:     PropTypes.oneOf([
			Flux.Constants.Vxql.Collection.Order.VIEWS,
			Flux.Constants.Vxql.Collection.Order.ALPHABETICAL,
		]),
        onLoaded:        PropTypes.func,
        first:           PropTypes.number,
        firstModels:     PropTypes.number,
        collectionNames: PropTypes.array,
	};
	withCategories.defaultProps = {
        sort:            Flux.Constants.Vxql.Collection.Order.VIEWS,
        first:           null,
        collectionNames: [],
        firstModels:     0,
	};

	return withCategories;
}

export default withCategories;
